import {
  Button,
  Dialog,
  DialogTitle,
  Fab,
  FormControlLabel,
  Grid,
  IconButton,
  Popover,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { ExoticComponent, Fragment, useEffect, useState } from "react";
import AtlasPanel from "../../atlas/blades/AtlasPanel";
import InfoIcon from "@material-ui/icons/Info";
import ProjectBilling from "./ProjectBilling";
const ProjectDetails: React.FC<any> = ({ theme, project, role, billing }) => {
  if (project === null) return <Fragment />;
  {
    /* <Grid item xs={12} lg={2}>
          <div className="portalLabel">Created</div>
          <div className="portalCopy">
            {new Date(project.updatedAt).toLocaleDateString()}
          </div>
        </Grid> */
  }
  {
    /* <Grid item xs={12} lg={2}>
          <div className="portalLabel">Permissions</div>
          <div className="portalCopy">{role}</div>
        </Grid> */
  }
  const [monthName, setMonthName] = useState("");
  const [totalCost, setTotalCost] = useState("");
  const [contactEls, setContactEls] = useState(<Fragment></Fragment>);
  const [showContactDetail, setShowContactDetail] = useState(false);
  const [showBillingDetail, setShowBillingDetail] = useState(false);
  const [showStatusDetail, setShowStatusDetail] = useState(false);

  useEffect(() => {
    const props = ["name", "role", "affiliation", "email", "phone"];
    const components = project.contact.reduce((components, contact) => {
      props.forEach((prop) => {
        if (contact[prop] !== null) {
          components.push(
            <div key={contact[prop]}>
              <div
                className="portalLabel"
                style={{ paddingTop: 20, textTransform: "capitalize" }}
              >
                {prop}
              </div>
              <div className="portalCopy" style={{ fontSize: 12 }}>
                {contact[prop]}
              </div>
            </div>
          );
        }
      });
      return components;
    }, []);
    setContactEls(components);
  }, [project]);
  useEffect(() => {
    const totalCost = billing.reduce((p, c) => {
      return p + parseFloat(c.value.replace("$", ""));
    }, 0);
    setTotalCost("$" + parseFloat(totalCost).toFixed(2));

    setMonthName(
      [
        "Jan",
        "Feb",
        "March",
        "April",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ][new Date().getMonth()]
    );
  }, [billing]);

  return (
    <AtlasPanel title={project.name}>
      <Grid container spacing={3} style={{ fontSize: 13 }}>
        <Grid item xs={12} lg={6}>
          <div className="portalLabel">Description</div>
          <div className="portalCopy">{project.desc}</div>
        </Grid>

        <Grid item xs={12} lg={2}>
          <span style={{ display: "inline-block" }}>
            <div className="portalLabel">Status</div>
            <div className="portalCopy">{project.status}</div>
          </span>
          <IconButton
            aria-label="details"
            size="small"
            style={{ position: "relative", top: "-10px", left: "5px" }}
            onClick={(e) => setShowStatusDetail(true)}
          >
            <InfoIcon style={{ width: "24px", height: "24px" }} />
          </IconButton>
        </Grid>
        <Grid item xs={12} lg={2}>
          <span style={{ display: "inline-block" }}>
            <div className="portalLabel">Contact</div>
            <div className="portalCopy">{project.contact[0].name}</div>
          </span>
          <IconButton
            aria-label="details"
            size="small"
            style={{ position: "relative", top: "-10px", left: "5px" }}
            onClick={(e) => setShowContactDetail(true)}
          >
            <InfoIcon style={{ width: "24px", height: "24px" }} />
          </IconButton>
        </Grid>
        <Grid item xs={12} lg={2}>
          <span style={{ display: "inline-block" }}>
            <div className="portalLabel">{monthName} Billing </div>
            <div className="portalCopy">{totalCost}</div>
          </span>
          <IconButton
            aria-label="details"
            size="small"
            style={{ position: "relative", top: "-10px", left: "5px" }}
            onClick={(e) => setShowBillingDetail(true)}
          >
            <InfoIcon style={{ width: "24px", height: "24px" }} />
          </IconButton>
        </Grid>
      </Grid>

      <Dialog
        onClose={() => setShowBillingDetail(false)}
        open={showBillingDetail}
      >
        <ProjectBilling billing={billing} />
      </Dialog>

      <Dialog
        onClose={() => setShowContactDetail(false)}
        open={showContactDetail}
      >
        <DialogTitle>Contact Details</DialogTitle>
        <div style={{ padding: "0px 30px 30px 30px" }}>{contactEls}</div>
      </Dialog>

      <Dialog
        onClose={() => setShowStatusDetail(false)}
        open={showStatusDetail}
      >
        <DialogTitle>Status Details</DialogTitle>
        <div style={{ padding: "30px" }}>
          <div style={{ paddingBottom: "20px" }}>
            Switch To Archive Project. Archiving allows you to save on your
            monthly costs by decommisioning compute resources and placing files
            in storage. You can reconsitite these resources, but it is not
            advisable to do this unless you plan to stop working with it for
            several weeks. You can turn on auto archiving to ...
          </div>
          <FormControlLabel
            control={<Switch />}
            label="Archive Now"
            style={{ paddingRight: "20px" }}
          />
          <FormControlLabel control={<Switch />} label="Auto Archive" />
        </div>
      </Dialog>
    </AtlasPanel>
  );
};

export default ProjectDetails;
